<template>
  <div class="draught-jujuna">
      <!-- <BarMap /> -->
    <div class="d-bar-container">
      <div class="img-wrapper">
        <div class="icon" v-html="getSvg"></div>
          <div class="inner-img-wrapper"> 
        <picture>
            <source media="(max-width:1023px)" :srcset="_.get(getImage, 'devices.tablet')">
            <source media="(max-width:767px)" :srcset="_.get(getImage, 'devices.mobile')">
        <img :src="_.get(getImage, 'devices.desktop')" :alt="_.get(getImage, 'title')" data-scroll data-scroll-speed="-1" prlx-intensity="20" class="ik_prlx" />
        </picture>
        </div> 
        <div class="ttl"><h2 class="f-55">{{ getTitle }}</h2></div>
      </div>
      <div class="text-block">
        <div class="editor" v-html="getTeaser"></div>
        <!-- <div class="bar-locations">
          <span class="light-italic f-16"
            >{{$fn.tr('რომელ ბარებშია ჩამოსასხმელი ჟუჟუნა?')}}</span
          >
          <div class="icon-wrapper" @click="openBarMap();">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="23.889"
              viewBox="0 0 20 23.889"
            >
              <g id="fi-ss-marker" transform="translate(-2)">
                <g id="Group_2077" data-name="Group 2077">
                  <path
                    id="Path_3878"
                    data-name="Path 3878"
                    d="M12,0A10.011,10.011,0,0,0,2,10c0,5.282,8.4,12.533,9.354,13.343l.646.546.646-.546C13.6,22.533,22,15.282,22,10A10.011,10.011,0,0,0,12,0Zm0,15a5,5,0,1,1,5-5,5,5,0,0,1-5,5Z"
                    fill="#044b30"
                  />
                  <circle
                    id="Ellipse_275"
                    data-name="Ellipse 275"
                    cx="3"
                    cy="3"
                    r="3"
                    transform="translate(9 7)"
                    fill="#044b30"
                  />
                </g>
              </g>
            </svg>

            <span class="bold-italic">{{$fn.tr('ბარები')}}</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import BarMap from '@/components/BarMap';
import prlx from "@/mixins/ik_prlx";
export default {
  props: [
    "contentData"
  ],
   mixins: [prlx],
    // components: {BarMap},
    computed: {
      getTitle() {
        return _.get(this.contentData, 'data.list.0.title')
      },
      getTeaser() {
        return _.get(this.contentData, 'data.list.0.teaser')
      },
      getImage() {
        return _.get(this.contentData, 'data.list.0.images.0')
      },
      getSvg() {
        return _.get(this.contentData, 'data.list.0.svg')
      }
    },
    methods: {
          openBarMap() {
          this.$store.commit("main/barMapStatus", !this.$store.state.main.barMapActive);
    }
    }
};
</script>

<style>
.draught-jujuna p,
.draught-jujuna .editor a,
.draught-jujuna .editor p,
.draught-jujuna .editor span, .draught-jujuna .editor em, .draught-jujuna .editor h1, .draught-jujuna .editor h2, .draught-jujuna .editor h3, .draught-jujuna .editor h4, .draught-jujuna .editor h5, .draught-jujuna .editor h6 {
  margin: 0;
  padding: 0;
  font-family: "FiraGO-Italic";
  will-change: transform;
}
.draught-jujuna strong, .draught-jujuna b{
  font-family: "FiraGO-BoldItalic";
  
}
.draught-jujuna .editor a {
  text-decoration: underline;
  color: #044B30;
}
.draught-jujuna .img-wrapper .ttl h2, 
.draught-jujuna .bar-locations span:nth-child(1),
.draught-jujuna .bar-locations .icon-wrapper span
{
  will-change: transform;
}

</style>
